import { useState, useEffect, memo } from "react";
import style from "./../index.module.scss";
import styleUi from "./FriendSearch.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import apiManager from './../../ApiManager';

const FriendSearch = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [friends, set_friends] = useState([]);
    const [filterUser, set_filterUser] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        setInProp(true);
        document.title = "朋友";
        apiManager.fetchGet(`user/friends`, {}, 0).then(res => {
            console.log("res", res)
            set_friends(res);
        })
    }, []);

    useEffect(() => {
        let filtered = [];
        console.log("friends",friends);
        if (searchTerm === "") {
            filtered = [...friends];
        } else {
            filtered = friends.filter(user =>
                user.user_friends_detail.user_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                user.user_friends_detail.user_username.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        console.log("user",filtered)
        filtered.sort((a, b) => {
            if (a.user_friends_status === b.user_friends_status) {
                return a.user_friends_detail.user_name.localeCompare(b.user_friends_detail.user_name, "zh-Hant");
            }
            return a.user_friends_status - b.user_friends_status;
        });
        set_filterUser(filtered);
    }, [searchTerm, friends]);


    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "FriendSearch"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                                    <YStyled.Span size={17} fontWeight={700}>朋友</YStyled.Span>
                                    <img src="./assets/ui/back.png" />
                                </div>
                                <div className={styleUi.view}>
                                    <div className={styleUi.subView}>
                                        <YStyled.Label style={{ padding: ".3rem .5rem", borderRadius: "35px", width: "100%",background:"#f4f4f4" }}>
                                            <YStyled.Input
                                                placeholder="輸入名稱或ID搜尋"
                                                value={searchTerm}
                                                onChange={handleInputChange}
                                            />
                                            {searchTerm !== "" ?
                                                <img src="./assets/ui/close_c.png" onClick={e => {
                                                    setSearchTerm("");
                                                }} />
                                                :
                                                <img src="./assets/ui/Search.png" />
                                            }
                                        </YStyled.Label>
                                        <div className={styleUi.list}>
                                            {
                                                filterUser.map((v, k) => {
                                                    return <div className={styleUi.item} key={k} onClick={e => {
                                                        arg.cb(v.user_friends_detail);
                                                        console.log("v.user_friends_detail",v.user_friends_detail)
                                                        setInProp(false);
                                                    }}>
                                                        <FriendInfo user={v.user_friends_detail} type={6} />
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(FriendSearch);
